/**
 * --------------------------------------------------------------------------
 * Collapse
 * --------------------------------------------------------------------------
 */

const collapse = ($ => {

	/**
	* ------------------------------------------------------------------------
	* Constants
	* ------------------------------------------------------------------------
	*/

	const Default = {};

	/**
	* ------------------------------------------------------------------------
	* Class Definition
	* ------------------------------------------------------------------------
	*/

	class Collapse {

		constructor(element, config) {
			this.element = element;
			this.config = config;
			this.parent = this.getParent(this.element);
			if (!$(this.element).attr('data-toggle')) {
				$(this.element).attr('data-toggle', 'collapse');
			}
			if (!$(this.element).attr('aria-expanded')) {
				$(this.element).attr('aria-expanded', 'false');
				this.getTarget(this.element)
					.addClass('collapse_state_hidden');
			}
			if (this.config.appearance) {
				$(this.element).attr('data-appearance', this.config.appearance);
			}
			if (this.parent){
				this.setOrder();
			}
		}

		getTarget(element) {

			let $target = {};

			if (this.config.target) {
				$target = $(this.config.target);
			}
			else if ($(element).attr('data-target')) {
				$target = $($(element).attr('data-target'));
			}
			else {
				$target = $(element).next('.collapse');
			}

			return $target;
		}

		getParent(element) {
			let parent = null;
			if ($(element).attr('data-parent')) {
				parent = $(this.element).attr('data-parent');
			}
			if (this.config.parent) {
				parent = this.config.parent;
				$(element).attr('data-parent', parent);
			}
			return parent;
		}

		show() {
			$(this.element)
				.attr('aria-expanded', 'true');
			this.getTarget(this.element)
				.removeClass('collapse_state_hidden');
		}

		hide() {
			$(this.element)
				.attr('aria-expanded', 'false');
			this.getTarget(this.element)
				.addClass('collapse_state_hidden');
		}

		toggle() {
			if ($(this.element).attr('aria-expanded') === 'true'){
				this.hide();
			}else {
				this.show();
				if (this.parent) {
					const $siblings = $(this.parent).find('[data-parent="' + this.parent + '"]').not($(this.element));
					$siblings.collapse('hide');
				}
			}
		}

		setOrder() {
			const $children = $(this.parent).find('[data-parent="' + this.parent + '"]');
			console.log($children);
			$children
				.first()
				.attr('data-order', 'first');
			$children
				.last()
				.attr('data-order', 'last');
			$children
				.slice(1, -1)
				.removeAttr('data-order');
		}

		destroy() {
			$(this.element).removeAttr('data-toggle');
			$(this.element).removeAttr('data-appearance');
			$(this.element).removeAttr('data-parent');
			$(this.element).removeAttr('aria-expanded');
			this.getTarget(this.element).removeClass('collapse_state_hidden');
			$.removeData(this.element, 'collapse');
			this.config = null;
			this.parent = null;
			this.element = null;
		}

		static jQueryInterface(param, ...rest) {
			return this.each(function () {
				const $this = $(this);
				let data = $this.data('collapse');

				const config = $.extend(
					{},
					Default,
					$(this).data(),
					typeof param === 'object' && param
				);

				if (!data) {
					data = new Collapse(this, config);
					$this.data('collapse', data);
				}

				if (typeof param === 'string') {
					if (typeof data[param] === 'undefined') {
						throw new Error('No method named "' + param + '"');
					}
					data[param](rest);
				}
			});
		}
}

	/**
	* ------------------------------------------------------------------------
	* Data Api implementation
	* ------------------------------------------------------------------------
	*/

	$(document)
		.ready(() => {
			$('[data-toggle="collapse"]')
				.each(function () {
					$(this).collapse();
				});
		})
		.click(() => {
			const $collapse = $(event.target).closest('[data-toggle="collapse"]');
			if ($collapse.length){
				$collapse.collapse('toggle');
			}
		});

	/**
	* ------------------------------------------------------------------------
	* jQuery
	* ------------------------------------------------------------------------
	*/

	$.fn.collapse = Collapse.jQueryInterface;
	$.fn.collapse.Constructor = Collapse;

	return Collapse;

})(jQuery);

export default collapse;



/** WEBPACK FOOTER **
 ** ./app/blocks/collapse/collapse.js
 **/